import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      d="M1.83737 1.84533C2.47785 1.20485 2.5983 0 2.86534 0C3.13238 0 3.25284 1.20485 3.89331 1.84533C4.53379 2.48581 5.73068 2.55365 5.73068 2.86538C5.73068 3.17712 4.53379 3.24495 3.89331 3.88543C3.25284 4.52591 3.13238 5.73076 2.86534 5.73076C2.5983 5.73076 2.47785 4.52591 1.83737 3.88543C1.19689 3.24495 0 3.17712 0 2.86538C0 2.55365 1.19689 2.48581 1.83737 1.84533Z"
      fill="#EE9E00"
    />
    <path
      d="M6.89714 6.90836C7.81888 5.98663 7.99223 4.25269 8.37653 4.25269C8.76084 4.25269 8.93419 5.98663 9.85594 6.90836C10.7776 7.8301 12.5001 7.92772 12.5001 8.37635C12.5001 8.82498 10.7776 8.9226 9.85594 9.8443C8.93419 10.7661 8.76084 12.5 8.37653 12.5C7.99223 12.5 7.81888 10.7661 6.89714 9.8443C5.97541 8.9226 4.25293 8.82498 4.25293 8.37635C4.25293 7.92772 5.97541 7.8301 6.89714 6.90836Z"
      fill="#EE9E00"
    />
  </svg>
);
